<template>
    <v-app-bar app v-if="$root.edit && $store.state.editMenu" height="48" class="zoezi-edit-font">
        <div class="d-flex" style="width: 100%; margin-top: 6px">
            <div class="d-flex">
                <v-img
                    alt="Logo"
                    class="shrink mr-2 d-inline-block"
                    contain
                    :src="$api.getAssetUrl('/assets/img/zoezi_icon.png')"
                    height="36"
                    width="36"
                    position="top left"
                />
                <v-btn :small="$vuetify.breakpoint.smAndDown" text><v-icon left>mdi-file-multiple</v-icon><span class="hidden-sm-and-down">{{$translate('Files')}}</span></v-btn>

                <v-menu offset-y :close-on-content-click="false" v-model="showPagesMenu">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" :small="$vuetify.breakpoint.smAndDown" text><v-icon left>mdi-book-open-page-variant</v-icon><span class="hidden-sm-and-down">Sidor</span></v-btn>
                    </template>

                    <v-list class="zoezi-edit-font zoezi-edit-menu-pages-list">
                        <v-list-item @click.stop="showAddPageDialog = true">
                            <v-icon left>mdi-file-plus-outline</v-icon>Skapa ny...
                            <add-page v-model="showAddPageDialog" />
                        </v-list-item>

                        <v-list-item @click.stop="showDuplicatePageDialog = true">
                            <v-icon left>mdi-file-multiple-outline</v-icon>{{$translate('Duplicate')}}...
                            <add-page v-model="showDuplicatePageDialog" :duplicate="true" />
                        </v-list-item>

                        <v-list-item @click.stop="showManagePagesDialog = true">
                            <v-icon left>mdi-file-edit-outline</v-icon>{{$translate('Manage pages')}}...
                            <manage-pages v-model="showManagePagesDialog" />
                        </v-list-item>


                        <v-divider />
                        <v-list-item>
                            <v-text-field v-model="searchPage" :label="$translate('Search page')" append-icon="mdi-magnify" single-line hide-details color="zoezi-edit-color" clearable />
                        </v-list-item>
                        <v-list-item
                            v-for="route in sortedRoutes"
                            :key="route.path"
                            :to="route.path"
                            exact-path
                        >
                            <v-list-item-content>
                                {{route.name}}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" :small="$vuetify.breakpoint.smAndDown" text><v-icon left>mdi-cube-outline</v-icon><span class="hidden-sm-and-down">{{$translate('Components')}}</span></v-btn>
                    </template>

                    <component-tree :show-close="false" :show-header="false" max-height="calc(100vh - 48px)" @select="$store.commit('setEditComponent', $event)"/>
                </v-menu>

                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" :small="$vuetify.breakpoint.smAndDown" text><v-icon left>mdi-cube-outline</v-icon><span class="hidden-sm-and-down">{{$translate('Own components')}}</span></v-btn>
                    </template>

                    <own-components-list />
                </v-menu>
            </div>
            <div class="d-flex flex-column flex-grow-1 text-center">
                <div class="hidden-sm-and-down">
                    <div class="text-uppercase text--secondary subtitle-2">{{$translate('Editing')}}</div><div v-zoezi-editable="{setProp: (value) => currentRoute.name = value, html: false, multiline: false}">{{currentRoute.name}}</div>
                </div>
            </div>
            <div class="d-flex">
                <v-btn :small="$vuetify.breakpoint.smAndDown" text><v-icon>mdi-magnify</v-icon></v-btn>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" :small="$vuetify.breakpoint.smAndDown" text><v-icon>mdi-cog</v-icon></v-btn>
                    </template>

                    <v-list class="zoezi-edit-font">
                        <v-list-item @click="$store.commit('setEditMenu', !$store.state.editMenu)">

                            <v-list-item-icon>
                                <v-icon>mdi-dock-left</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Switch to sidebar')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="leaveEditMode">
                            <v-list-item-icon>
                                <v-icon>mdi-close</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$translate('Close editing mode')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn :small="$vuetify.breakpoint.smAndDown" text><v-icon left>mdi-account</v-icon><span class="hidden-sm-and-down">{{$store.state.user.firstname}}</span></v-btn>
            </div>
        </div>
    </v-app-bar>
</template>

<script>
import ComponentTree from '../components/ComponentTree.vue'
import AddPage from '../components/AddPage.vue'
import ManagePages from '../components/ManagePages.vue'
import OwnComponentsList from './OwnComponentsList.vue'
import { eraseCookie } from '../util'
export default {
    name: 'zoezi-edit-menu',

    components: {
        ComponentTree,
        AddPage,
        ManagePages,
        OwnComponentsList
    },

    computed: {
        currentRoute() {
            return this.$root.siteconfig.routes.map(r => r.props).find(r => r.path == this.$route.path);
        },
        sortedRoutes() {
            let s = (this.searchPage || '').toLowerCase();
            return this.$root.siteconfig.routes.map(r => r.props).filter(r => !s || r.path.includes(s) || r.name.toLowerCase().includes(s)).sort((a, b) => a.name.localeCompare(b.name));
        },
        currentPageComponent() {
            let elm = document.getElementById(this.currentRoute.id);
            return elm && elm.__vue__;
        }
    },

    data: () => ({
        showPagesMenu: false,
        showAddPageDialog: false,
        showDuplicatePageDialog: false,
        showManagePagesDialog: false,
        searchPage: ''
    }),

    methods: {
        leaveEditMode() {
            this.$root.edit = false;
            this.$root.mobilePreview = false;
            eraseCookie('editmode');
            window.location.reload();
        }
    }
}
</script>
